import { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

const NavBarWithSearch = lazy(
  () => import('../components/navigation/searchbar/NavSearchBar')
);

const HomeView = lazy(() => import('../views/home/HomeView'));
const CategoryView = lazy(() => import('../views/category/CategoryView'));
const DetailView = lazy(() => import('../views/detail/DetailView'));
const VariationView = lazy(() => import('../views/variation/VariationView'));
const SearchView = lazy(() => import('../views/search/SearchView'));
const Terms = lazy(() => import('../views/static/terms/Terms'));
const Policy = lazy(() => import('../views/static/policy/Policy'));
const About = lazy(() => import('../views/static/about/About'));
const Help = lazy(() => import('../views/static/help/Help'));
const BibtexView = lazy(() => import('../views/bibtex/BibtexView'));
const SitemapHandler = lazy(() => import('../views/sitemap/SitemapHandler'));

export const shouldShowNavBar = (pathName: string): boolean =>
  pathName !== '/login' && pathName !== '/';

function RouterComponent() {
  const location = useLocation();
  let NavBarComponent = null;
  const pathName = location.pathname;

  if (shouldShowNavBar(pathName)) {
    NavBarComponent = <NavBarWithSearch />;
  }

  function renderRoutes() {
    return (
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/" element={<HomeView />} />
          <Route path="/category/:category" element={<CategoryView />} />
          <Route path="/move/:move" element={<DetailView />} />
          <Route path="/variation/:variation" element={<VariationView />} />
          <Route path="/search" element={<SearchView />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          <Route path="/bibtex" element={<BibtexView />} />
          {/* Sitemap routes - exact paths first, then catch-all */}
          <Route path="/sitemap.xml" element={<SitemapHandler />} />
          <Route path="/sitemap-pages.xml" element={<SitemapHandler />} />
          <Route path="/sitemap-categories.xml" element={<SitemapHandler />} />
          <Route path="/sitemap-moves-:page.xml" element={<SitemapHandler />} />
          <Route path="/sitemap/*" element={<SitemapHandler />} />
          {/* Handle common typos */}
          <Route path="/sitmap.xml" element={<SitemapHandler />} />
          <Route path="/sitmap/*" element={<SitemapHandler />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <>
      <Suspense fallback={<div></div>}>
        <div>{NavBarComponent}</div>
      </Suspense>
      {renderRoutes()}
    </>
  );
}

export default RouterComponent;
